module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/icon_1_folder_x32-36fac.png";